/**
 * Baut die Such-URI für den paginierten Mandanten-Endpoint (`/legalclient?…`).
 * Sucht per "includes" über Nachname, Vorname und E-Mail. Gibt `undefined`
 * zurück, solange weniger als zwei Zeichen eingegeben sind – so bleibt der
 * react-query-Hook (enabled: !!searchUri) deaktiviert und es wird nichts
 * geladen.
 *
 * @param term  der eingegebene Suchbegriff
 * @param rowsPerPage  max. Trefferzahl (Default 20)
 */
export const buildLegalClientSearchUri = (
  term: string,
  rowsPerPage = 20
): string | undefined => {
  const query = term.trim();
  if (query.length < 2) return undefined;

  const fields = ['LastName', 'FirstName', 'Email'];
  const search = fields.map(field => `${field}:${query}`).join(';');
  return `search=${search};&searchtype=includes&page=1&rowsPerPage=${rowsPerPage}`;
};
